<!-- eslint-disable vue/no-v-html -->
<template>
  <Container v-if="data.typeForm === 'center'" class="!max-w-[1292px]">
    <div class="flex flex-col items-center">
      <div class="max-w-[650px]">
        <SubTitle class="mb-3 text-blue lg:mb-0">{{ data?.subtitle }}</SubTitle>
        <Title
          :custom-style="twMerge('mb-5 text-3xl lg:text-4xl', useDarkMode ? 'text-white' : '')"
          >{{ data?.title }}</Title
        >
        <div
          :class="
            twMerge(
              'mb-8 font-sans text-base lg:mb-12 lg:text-lg',
              useDarkMode ? 'text-white' : 'text-black',
            )
          "
          v-html="data?.copy"
        ></div>
      </div>
      <NuxtImg
        v-if="data?.image?.url && data?.image?.type !== 'url'"
        provider="cloudinary"
        class="mb-8 aspect-[3/2] rounded-xl object-cover lg:rounded-2xl xl:mb-0 xl:aspect-[1.9]"
        :src="data?.image?.url"
        :alt="data?.image?.alt || data?.title"
        height="504"
        fit="fill"
        sizes="xs:100vw sm:100vw lg:100vw"
      />

      <CloudinaryResponsivePicture
        v-if="data?.image?.url && data?.image?.type === 'url'"
        class="mb-8 aspect-[3/2] rounded-xl object-cover lg:rounded-2xl xl:mb-0 xl:aspect-[1.9]"
        :src="data.image.url"
        :alt="data.image.alt || data.title"
        :breakpoints="[480, 768, 1024, 1200]"
        sizes="xs:480 sm:768 md:1024 lg:1200"
        loading="lazy"
      />
      <div class="max-w-[650px] lg:-translate-y-20">
        <Form v-if="data?.form" :data="data?.form" />
        <slot></slot>
      </div>
    </div>
  </Container>
  <Container v-else class="!max-w-[1362px]">
    <div class="flex flex-col xl:flex-row">
      <div class="basis-1/2 xl:pr-12">
        <SubTitle class="mb-3 text-blue lg:mb-0">{{ data?.subtitle }}</SubTitle>
        <Title
          :custom-style="twMerge('mb-5 text-3xl lg:text-4xl', useDarkMode ? 'text-white' : '')"
          >{{ data?.title }}</Title
        >
        <div
          :class="
            twMerge(
              'mb-8 font-sans text-base lg:mb-12 lg:text-lg',
              useDarkMode ? 'text-white' : 'text-black',
            )
          "
          v-html="data?.copy"
        ></div>

        <Image
          v-if="data?.image?.url && data?.image?.type !== 'url'"
          class="mb-8 aspect-[3/2] rounded-xl object-cover lg:rounded-2xl xl:mb-0 xl:aspect-[1.9]"
          :url="data?.image?.url"
          :alt="data?.image?.alt"
          width="600"
          height="500"
          sizes="xs:100vw sm:500"
          fit="cover"
        />

        <CloudinaryResponsivePicture
          v-if="data?.image?.url && data?.image?.type === 'url'"
          class="mb-8 aspect-[3/2] rounded-xl object-cover lg:rounded-2xl xl:mb-0 xl:aspect-[1.9]"
          :src="data.image.url"
          :alt="data.image.alt || data.title"
          :breakpoints="[480, 768, 1024, 1200]"
          sizes="xs:480 sm:768 md:1024 lg:1200"
          loading="lazy"
        />
      </div>
      <div class="flex basis-1/2 flex-col justify-end xl:pl-12">
        <Form v-if="data?.form" :data="data?.form" />
        <slot></slot>
      </div>
    </div>
  </Container>
</template>

<script setup lang="ts">
import { Title, SubTitle, Container, NuxtImg, CloudinaryResponsivePicture, Image } from 'refresh-ui'
import { twMerge } from 'tailwind-merge'
import Form from '~/components/molecules/Form.vue'

defineProps({
  data: { type: Object, required: true },
  useDarkMode: { type: Boolean, required: false },
})
</script>
